/**
 * Message Type that can be sent to a ChargePoint
 */
export enum ChargingRateUnitType {
   W = 'W',
   A = 'A'
}
